import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ shape, custom }: Theme) => ({
  root: {
    height: 43,
    width: '100%',
    marginTop: 12,
  },
  sm: {
    maxWidth: 200,
  },
  md: {
    maxWidth: 280,
  },
  lg: {
    maxWidth: 430,
  },
  xl: {
    maxWidth: 580,
  },
  full: {
    width: '100%',
  },
  placeholderRectShape: {
    borderRadius: shape.borderRadius,
    backgroundColor: custom.grey[6],
  },
}));
